export default {
  init($element) {

  },
  finalize($element) {
    $element.find('.section-header').on('click', function() {
      $(this).parent().toggleClass('closed');
      $(this).siblings('.section-body').stop().slideToggle(200);
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/iconAndTextLinks.js